import React, { useState, useEffect } from "react";


import { Skeleton } from "@mui/material";

import Services from "../Components/Home/Services/Services";
import HeroSection from "../Components/Home/Hero/HeroSection";
import SodexoPaymentFunction from "../Components/Home/Deal/SodexoPayment";
import MapsComponent from "./maps";
import CompanySwipe from "./CompanySwipe";
import Footer from "../Components/Footer/Footer";
import ProductList from "../Components/Home/ProductList/Products";

const Home: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 100);
    return () => clearTimeout(timer); // cleanup timeout
  }, []);

  return (
    <>
   
  

      {loading ? (
        <div
          style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}
        >
          <Skeleton
            variant="rectangular"
            width="100vw"
            height="100vh"
            animation="wave"
            sx={{
              bgcolor: "rgba(0, 0, 0, 0.1)",
              "& .MuiSkeleton-wave": {
                background:
                  "linear-gradient(90deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.15) 100%)",
              },
            }}
          />
        </div>
      ) : (
        <>
          <HeroSection />
          <Services />
          <ProductList />
          <SodexoPaymentFunction/>
          <MapsComponent />
          <CompanySwipe/>
        </>
      )}

      <Footer />
    </>
  );
};

export default Home;
